// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jnxvkfugsktglknkafxx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpueHZrZnVnc2t0Z2xrbmthZnh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA4MTM5OTYsImV4cCI6MjA5NjM4OTk5Nn0.kf8tjSm9Cz6r1qkdI7RD0pYG7eQWkH_vw46AQpAdZRI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});